import { ListSortOrder, ListViewTypes } from '@nextiva/engagement-ui';
import { SurveyListSortableFields } from 'constants';
import { ALL } from 'constants/surveyList/SurveyTabKeys';
import { paginationLimit } from './Pagination';

const { CREATED_AT } = SurveyListSortableFields;
const { DESCENDING } = ListSortOrder;
const { TABLE } = ListViewTypes;

export default {
  paginationLimit,
  tabName: ALL,
  sortOrder: DESCENDING,
  sortBy: CREATED_AT,
  searchPreviewSurveyCount: 0,
  listView: TABLE,
};
